module.exports = __webpack_public_path__ + "static/img/staff.2336e4b6.png";